import styled from 'styled-components';

import { mediaSize } from '../../../styles';

export const DetailItem = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: baseline;

  &:not(:last-child) {
    margin-bottom: 15px;
  }
  ${({ noMargin }) => noMargin && 'margin-bottom: 0 !important'}
`;

export const AddBudget = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.fontTangerine};

  &:hover {
    text-decoration: underline;
  }
`;

export const BudgetView = styled.span`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  margin-right: 5px;
`;

export const MeetingInfoWrapper = styled.div`
  margin-top: 20px;
`;

export const LinkWrapper = styled.a`
  display: flex;
  width: max-content;
  color: ${({ theme }) => theme.colors.fontTangerine};

  svg {
    margin-left: 10px;
  }

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.fontTangerine};
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  & > * {
    margin-top: 18px;
    width: 100%;
  }
`;

export const InfoWrapper = styled.div`
  padding: ${({ noStyle }) => noStyle ? '0' : '5px 10px 10px'};
  width: 100%;
  max-width: 100%;
  border-bottom: solid 1px ${({ theme }) => theme.colors.borderLightSilver};
  border-width: ${props => props.noStyle ? '0' : '1'};

  @media (min-width: ${mediaSize.desktop}) {
    padding: ${props => props.noStyle ? '0' : '20px 15px'};
    box-sizing: border-box;
    min-width: 280px;
    border-bottom: none;
    border-right: solid 1px ${({ theme }) => theme.colors.borderLightSilver};
    border-width: ${props => props.noStyle ? '0' : '1'};

    ${Controls} {
      justify-content: left;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-info/styled-components.js